<template>
  <div class="recipe_add">
    <br />
    <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>药品管理</el-breadcrumb-item>
            <el-breadcrumb-item>添加/修改</el-breadcrumb-item>
        </el-breadcrumb>
    <br />
    <hr />


    <br />
    <el-main>
      <div class="form-region-header font-30">基本信息</div>
      <el-form ref="form" :model="form" label-width="200px">
        <table>
          <tr>
            <td>
              <el-form-item label="药品库">
                <el-input v-model="form.name" placeholder="" clearable></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="3"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">附件不超过500kb</div>
                </el-upload>
            </td>
          </tr>
           <tr>
            <td>
              <a href="">点击下载导入模板</a>
            </td>
          </tr>
        </table>
      </el-form>
    </el-main>
    <el-footer>
      <el-button type="primary" @click="onSubmit('form')">提交</el-button>
      <el-button @click="goback('form')">返回</el-button>
    </el-footer>
    <!--
        </el-container>
      </el-tab-pane>
    </el-tabs>
    -->
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "drugAdd",
  data() {
    return {
      activeName: "first",
      RegisterUserAPI: "https://yc.suyizaixian.com:30005/XXXXXXXXXXXXXXXXXXXXXX",
      fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],
      form: {
        name: "",
        phone: "",
        sex: "男",
        age: "",
        ctizenID: "",
        special: "否",
        specialdetail: "备孕",
        hisAllergy: "否",
        allergyDesc: "",
        hisLiver: "否",
        liverillDesc: "",
        hisKidney: "否",
        kidneyillDesc: "",
        hisHypertension: "否",
        highHypertension: "",
        lowHypertension: "",
        hisDiabete: "否",
        diabetesDesc: "",
        hisHeart: "否",
        heartDiseaseDesc: "",
        hisOther: "否",
        otherDiseaseDesc: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        medicine: [
          { required: true, message: "请选择药品名字", trigger: "change" }
        ]
      }
    };
  },
  props: {
    msg: String
  },
  methods: {
    goback(formname) {
      // 点击返回按钮，向后跳转
      this.$router.replace("/AddDrug");
    },
    gotonext() {
      this.$router.replace("/RecipeAdd2");
    },
    handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
    onSubmit(formName) {
      console.log(formName);
      if (this.form.special == "是" && this.form.sex == "男") {
        alert("患者性别与特殊人群冲突");
      } else if (
        this.form.hisHypertension == "是" &&
        (this.form.highHypertension.trim() == "" ||
          this.form.lowHypertension.trim() == "")
      ) {
        alert("请正确添加血压数值");
      } else {
        this.$confirm("是否确认注册?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            //this.axios
            //.get(this.RegisterUserAPI)
            //.then(response => (this.info = response.data))
            //.catch(function(err) {
            //    alert(err);
            //});

            var SpecialGroupType;
            if (this.form.special == "否") {
              SpecialGroupType = 1;
            } else {
              switch (this.form.specialdetail) {
                case "备孕":
                  SpecialGroupType = 2;
                  break;
                case "孕妇":
                  SpecialGroupType = 3;
                  break;
                case "产妇":
                  SpecialGroupType = 4;
                  break;
                case "哺乳期":
                  SpecialGroupType = 5;
                  break;
                default:
                  SpecialGroupType = 2;
                  break;
              }
            }
            var highPressureDesc = "";
            if (this.form.hisHypertension == "是") {
              highPressureDesc =
                "高压" +
                this.form.highHypertension +
                "mmgh,低压" +
                this.form.lowHypertension +
                "mmgh";
            }
            let datas = {
              name: this.form.name,
              phone: this.form.phone + "",
              sex: this.form.sex == "男" ? 1 : 2,
              age: this.form.age,
              ctizenID: this.form.ctizenID + "",
              SpecialGroupType: SpecialGroupType,
              isAllergy: this.form.hisAllergy == "否" ? 0 : 1,
              allergyDesc:
                this.form.hisAllergy == "否" ? "" : this.form.allergyDesc,
              isliverill: this.form.hisLiver == "否" ? 0 : 1,
              liverillDesc:
                this.form.hisLiver == "否" ? "" : this.form.liverillDesc,
              isKidneyill: this.form.hisKidney == "否" ? 0 : 1,
              kidneyillDesc:
                this.form.hisKidney == "否" ? "" : this.form.kidneyillDesc,
              isHighPressure: this.form.hisHypertension == "否" ? 0 : 1,
              highPressureDesc:
                this.form.hisHypertension == "否" ? "" : highPressureDesc,
              isDiabetes: this.form.hisDiabete == "否" ? 0 : 1,
              diabetesDesc:
                this.form.hisDiabete == "否" ? "" : this.form.diabetesDesc,
              isHeartDisease: this.form.hisHeart == "否" ? 0 : 1,
              heartDiseaseDesc:
                this.form.hisHeart == "否" ? "" : this.form.heartDiseaseDesc,
              isOtherDisease: this.form.hisOther == "否" ? 0 : 1,
              otherDiseaseDesc:
                this.form.hisOther == "否" ? "" : this.form.otherDiseaseDesc
            };
            console.log(datas);
            this.axios
              .post(this.RegisterUserAPI, qs.stringify(datas))
              .then(response => {
                let res = response.data;
                //console.log(res);
                if (res.data.result == "success") {
                  this.$router.replace("/RecipeAdd2");
                } else if (
                  res.data.result == "fail" &&
                  res.data.err.code == "ER_DUP_ENTRY"
                ) {
                  alert("该手机号已注册过，无法再次注册");
                }
              });
            //this axios.get('url',{datas:datas});  or else preflight response
          }).catch((e) => { alert(e+"，登录超时，请重新登录");});
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }else{
    var phoneNumber = sessionStorage.getItem("userPhone");
    this.form.phone = phoneNumber;
    //console.log("获取当前用户个人信息");
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
